import { IInjectButtonsParams } from './types'

export const WINDOW = window as Window &
  typeof globalThis & {
    DorisWidget: { rerenderStartButton: (props: Pick<IInjectButtonsParams, 'skus' | 'validateSku'>) => void }
  }
